import React, { useEffect, useMemo, useState } from 'react';
import {
  SimpleView,
  GridView,
  Widget,
  Table,
  Button,
  FilterWidget,
  FormContext,
  FormSelect,
  CompositeView
} from '@digital/ui';
import { ExcelButton, SearchButton } from '@app/components/FormButtons';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { getAllDiretoriasOptions } from '@app/api/diretoria';
import { getAllAreasOptions } from '@app/api/area';
import { getAllDepartamentoOptions } from '@app/api/departamento';
import { getContratoOptionsForSelect } from '@app/api/contrato';
import { exportToExcel, findAll } from '@app/api/relatorioSubcontratacoes';
import { mountFormFilterDropDown } from '@app/utils/formFilterDropDown';
import { compareDates, compareText } from '@app/helpers/comparators';
import moment from 'moment';
import { convertUTCtoLocal } from '@app/helpers/dateTimeFormats';

const RelatorioSubContratacao = () => {
  const [data, setData] = useState([]);

  const columns = [
    {
      title: 'NÚMERO',
      dataIndex: 'numeroContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.numeroContrato, b.numeroContrato),
      ...mountFormFilterDropDown('numeroContrato', 'Pesquisar'),
    },
    {
      title: 'CÓDIGO',
      dataIndex: 'codigoFornecedor',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.codigoFornecedor, b.codigoFornecedor),
      ...mountFormFilterDropDown('codigoFornecedor', 'Pesquisar'),
    },
    {
      title: 'CNPJ',
      dataIndex: 'cnpjContratada',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.cnpjContratada, b.cnpjContratada),
      ...mountFormFilterDropDown('cnpjContratada', 'Pesquisar'),
    },
    {
      title: 'NOME',
      dataIndex: 'nomeContratada',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.nomeContratada, b.nomeContratada),
      ...mountFormFilterDropDown('nomeContratada', 'Pesquisar'),
    },
    {
      title: 'OBJETO RESUMIDO',
      dataIndex: 'objetoResumidoContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.objetoResumidoContrato, b.objetoResumidoContrato),
      ...mountFormFilterDropDown('objetoResumidoContrato', 'Pesquisar'),
    },
    {
      title: 'STATUS',
      dataIndex: 'statusContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.statusContrato, b.statusContrato),
      ...mountFormFilterDropDown('statusContrato', 'Pesquisar'),
    },
    {
      title: 'Subcontratada',
      dataIndex: 'subcontratacao',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.subcontratacao, b.subcontratacao),
      ...mountFormFilterDropDown('subcontratacao', 'Pesquisar'),
    },
    {
      title: 'CNPJ Subcontratada',
      dataIndex: 'subcontratadaCnpj',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.subcontratacao, b.subcontratacao),
      ...mountFormFilterDropDown('subcontratadaCnpj', 'Pesquisar'),
    },
    {
      title: 'DATA INCLUSÃO',
      dataIndex: 'dataInclusaoSubcontratacaoFormatada',
      width: '20%',
      sorter: (a: any, b: any) => compareDates(a.dataInclusaoSubcontratacao, b.dataInclusaoSubcontratacao),
      ...mountFormFilterDropDown('dataInclusaoSubcontratacao', 'Pesquisar'),
    },
    {
      title: 'DATA INÍCIO SUBCONTRATAÇÃO',
      dataIndex: 'dataInicioSubcontratacaoFormatada',
      width: '20%',
      sorter: (a: any, b: any) => compareDates(a.dataInicioSubcontratacao, b.dataInicioSubcontratacao),
      ...mountFormFilterDropDown('dataInicioSubcontratacao', 'Pesquisar'),
    },
    {
      title: 'DATA FIM SUBCONTRATAÇÃO',
      dataIndex: 'dataFimSubcontratacaoFormatada',
      width: '20%',
      sorter: (a: any, b: any) => compareDates(a.dataFimSubcontratacao, b.dataFimSubcontratacao),
      ...mountFormFilterDropDown('dataFimSubcontratacao', 'Pesquisar'),
    },
    {
      title: 'Mo em PTR?',
      dataIndex: 'moEmPTR',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.moEmPTR, b.moEmPTR),
      ...mountFormFilterDropDown('moEmPTR', 'Pesquisar'),
    },
    {
      title: 'Diretoria',
      dataIndex: 'diretoriaContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.diretoriaContrato, b.diretoriaContrato),
      ...mountFormFilterDropDown('diretoriaContrato', 'Pesquisar'),
    },
    {
      title: 'Área',
      dataIndex: 'areaContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.areaContrato, b.areaContrato),
      ...mountFormFilterDropDown('areaContrato', 'Pesquisar'),
    },
    {
      title: 'Departamento',
      dataIndex: 'departamentoContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.departamentoContrato, b.departamentoContrato),
      ...mountFormFilterDropDown('departamentoContrato', 'Pesquisar'),
    },
    {
      title: 'Gestor MRN',
      dataIndex: 'gestorMRNContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.gestorMRNContrato, b.gestorMRNContrato),
      ...mountFormFilterDropDown('gestorMRNContrato', 'Pesquisar'),
    },
    {
      title: 'Fiscal MRN',
      dataIndex: 'fiscalMRNContrato',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.fiscalMRNContrato, b.fiscalMRNContrato),
      ...mountFormFilterDropDown('fiscalMRNContrato', 'Pesquisar'),
    },
    {
      title: 'ADMINISTRADOR GPC',
      dataIndex: 'administradorGpc',
      width: '20%',
      sorter: (a: any, b: any) => compareText(a.administradorGpc, b.administradorGpc),
      ...mountFormFilterDropDown('administradorGpc', 'Pesquisar'),
    },
  ];

  useState(()=>{
    findAll({}).then((resp: any) => resp && setData(
      resp.map((item: any) => {
        return {
          ...item,
          moEmPTR: item.moEmPTR ? 'Sim' : 'Não'
        };
      })
    ));
  },[])

  const handleFilter = (values: any) => {
    findAll(values).then((resp: any) => resp && setData(
      resp.map((item: any) => {
        return {
          ...item,
          moEmPTR: item.moEmPTR ? 'Sim' : 'Não'
        };
      })
    ));
  };

  const handleExcel = async (values: any) => {
      exportToExcel(values);
  };

  return (
    <CompositeView>
      <SimpleView>
        <GridView onSubmit={handleFilter}>
          <FormContext.Consumer>
            {({ formProps }) => (
              <FilterWidget
                active={[]}
                actions={[
                  <ExcelButton type="link" key="excelBtn" onClick={handleExcel} />,
                  <SearchButton type="primary" key="filterBtn" onClick={handleFilter} />,
                ]}
                title='Filtros'
              >
                <FormSelect
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, item: any) => {
                      return item.props.children.props.id
                        .toString()
                        .toLowerCase()
                        .includes(input.toLowerCase());
                    }}
                    mode="multiple"
                    label="Diretoria"
                    name="diretoriaIds"
                    getOptions={getAllDiretoriasOptions}
                    span={4}
                />
                <FormSelect
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                    mode="multiple"
                    label="Área"
                    name="areaIds"
                    getOptions={getAllAreasOptions}
                    span={4}
                />
                <FormSelect
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                    mode="multiple"
                    label="Departamento"
                    name="departamentosIds"
                    getOptions={getAllDepartamentoOptions}
                    span={4}
                />
                <FormSelect
                    showSearch
                    optionFilterProp="children"
                    filterOption={(input: any, item: any) => {
                        return item.props.children.props.id
                            .toString()
                            .toLowerCase()
                            .includes(input.toLowerCase());
                    }}
                    mode="multiple"
                    label="Contrato"
                    name="contratosIds"
                    getOptions={getContratoOptionsForSelect}
                    span={12}
                />
            </FilterWidget>
            )}
          </FormContext.Consumer>

          <Widget title="Relatório de Subcontratações">
            <Table
              columns={columns}
              dataSource={data}
              pagination={{ pageSize: 50 }}
            />
          </Widget>
        </GridView>
      </SimpleView>
    </CompositeView>
  );
};

export default RelatorioSubContratacao;
